module.exports = __webpack_public_path__ + "static/media/instalation.83742a55.svg";